var exports = {
  "k": "xcc377c0b--bb54f7--container",
};

module.exports = exports;
